import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { SeoPageLayout } from '@/components/layout/SeoPageLayout';
import { FAQs, Paragraph, PropsConsList, SemiBold, SubHeader, Table, UnorderedList } from '@/components/seo';
import { LINKS } from '@/constants/links';
import { isAllowedRoute } from '@/lang/pagesConfig';
import { NumericRange } from '@/types/range';
import { getIntlProps, type IntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
interface Props extends IntlProps {
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function Page(t0) {
  const $ = _c(737);
  const {
    menuPromoBanners
  } = t0;
  usePageView("seo-credit-card");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["seoCreditCard", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== t) {
    t2 = Array.from({
      length: 6
    }, (_, index) => {
      const faqIndex = index + 1 as NumericRange<1, 6>;
      return {
        question: t(`seoCreditCard:sections.faqs.${faqIndex}.question`),
        answer: t(`seoCreditCard:sections.faqs.${faqIndex}.answer`)
      };
    });
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const faqsData = t2;
  let t3;
  if ($[3] !== t) {
    t3 = t("seoCreditCard:seo.title");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("seoCreditCard:seo.description");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = {
      title: t3,
      description: t4
    };
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <br />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  let t8;
  if ($[11] !== t) {
    t7 = <Trans t={t} i18nKey="seoCreditCard:header.title">{t6}</Trans>;
    t8 = t("seoCreditCard:header.intro");
    $[11] = t;
    $[12] = t7;
    $[13] = t8;
  } else {
    t7 = $[12];
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <p>{t8}</p>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t) {
    t10 = t("seoCreditCard:header.button");
    $[16] = t;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = LINKS();
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10) {
    t12 = {
      label: t10,
      to: t11.registration
    };
    $[19] = t10;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t) {
    t13 = t("seoCreditCard:sections.1.title");
    $[21] = t;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t) {
    t15 = <Trans t={t} i18nKey="seoCreditCard:sections.1.content" components={t14} />;
    $[24] = t;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t13 || $[27] !== t15) {
    t16 = {
      title: t13,
      content: t15
    };
    $[26] = t13;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t) {
    t17 = t("seoCreditCard:sections.2.title");
    $[29] = t;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = {
      paragraph: <Paragraph />
    };
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t) {
    t19 = <Trans t={t} i18nKey="seoCreditCard:sections.2.content" components={t18} />;
    $[32] = t;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = [...Array(4)];
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t) {
    t21 = t20.map((__0, i) => {
      const transIndex = i + 1 as NumericRange<1, 4>;
      return <Trans key={i} t={t} i18nKey={`seoCreditCard:sections.2.subsections.${transIndex}`} components={{
        subheader: <SubHeader />,
        paragraph: <Paragraph />,
        semibold: <SemiBold />
      }} />;
    });
    $[35] = t;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== t19 || $[38] !== t21) {
    t22 = <>{t19}{t21}</>;
    $[37] = t19;
    $[38] = t21;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== t17 || $[41] !== t22) {
    t23 = {
      title: t17,
      content: t22
    };
    $[40] = t17;
    $[41] = t22;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  let t24;
  if ($[43] !== t) {
    t24 = t("seoCreditCard:sections.3.title");
    $[43] = t;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[45] = t25;
  } else {
    t25 = $[45];
  }
  let t26;
  if ($[46] !== t) {
    t26 = <Trans t={t} i18nKey="seoCreditCard:sections.3.content1" components={t25} />;
    $[46] = t;
    $[47] = t26;
  } else {
    t26 = $[47];
  }
  let t27;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = [...Array(2)];
    $[48] = t27;
  } else {
    t27 = $[48];
  }
  let t28;
  if ($[49] !== t) {
    t28 = t27.map((__1, i_0) => {
      const transIndex_0 = i_0 + 1 as NumericRange<1, 2>;
      return <Trans key={i_0} t={t} i18nKey={`seoCreditCard:sections.3.subsections.${transIndex_0}`} components={{
        subheader: <SubHeader />,
        paragraph: <Paragraph />,
        semibold: <SemiBold />
      }} />;
    });
    $[49] = t;
    $[50] = t28;
  } else {
    t28 = $[50];
  }
  let t29;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = {
      paragraph: <Paragraph />
    };
    $[51] = t29;
  } else {
    t29 = $[51];
  }
  let t30;
  if ($[52] !== t) {
    t30 = <Trans t={t} i18nKey="seoCreditCard:sections.3.content2" components={t29} />;
    $[52] = t;
    $[53] = t30;
  } else {
    t30 = $[53];
  }
  let t31;
  if ($[54] !== t26 || $[55] !== t28 || $[56] !== t30) {
    t31 = <>{t26}{t28}{t30}</>;
    $[54] = t26;
    $[55] = t28;
    $[56] = t30;
    $[57] = t31;
  } else {
    t31 = $[57];
  }
  let t32;
  if ($[58] !== t24 || $[59] !== t31) {
    t32 = {
      title: t24,
      content: t31
    };
    $[58] = t24;
    $[59] = t31;
    $[60] = t32;
  } else {
    t32 = $[60];
  }
  let t33;
  if ($[61] !== t) {
    t33 = t("seoCreditCard:sections.4.title");
    $[61] = t;
    $[62] = t33;
  } else {
    t33 = $[62];
  }
  let t34;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[63] = t34;
  } else {
    t34 = $[63];
  }
  let t35;
  if ($[64] !== t) {
    t35 = <Trans t={t} i18nKey="seoCreditCard:sections.4.content1" components={t34} />;
    $[64] = t;
    $[65] = t35;
  } else {
    t35 = $[65];
  }
  let t36;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = {
      subheader: <SubHeader />
    };
    $[66] = t36;
  } else {
    t36 = $[66];
  }
  let t37;
  if ($[67] !== t) {
    t37 = <Trans t={t} i18nKey="seoCreditCard:sections.4.subtitle" components={t36} />;
    $[67] = t;
    $[68] = t37;
  } else {
    t37 = $[68];
  }
  let t38;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = [...Array(3)];
    $[69] = t38;
  } else {
    t38 = $[69];
  }
  let t39;
  if ($[70] !== t) {
    t39 = <UnorderedList items={t38.map((__2, i_1) => {
      const transIndex_1 = i_1 + 1 as NumericRange<1, 3>;
      return <Trans key={i_1} t={t} i18nKey={`seoCreditCard:sections.4.list.${transIndex_1}`} />;
    })} className="mb-8" />;
    $[70] = t;
    $[71] = t39;
  } else {
    t39 = $[71];
  }
  let t40;
  if ($[72] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = {
      paragraph: <Paragraph />
    };
    $[72] = t40;
  } else {
    t40 = $[72];
  }
  let t41;
  if ($[73] !== t) {
    t41 = <Trans t={t} i18nKey="seoCreditCard:sections.4.content2" components={t40} />;
    $[73] = t;
    $[74] = t41;
  } else {
    t41 = $[74];
  }
  let t42;
  if ($[75] !== t35 || $[76] !== t37 || $[77] !== t39 || $[78] !== t41) {
    t42 = <>{t35}{t37}{t39}{t41}</>;
    $[75] = t35;
    $[76] = t37;
    $[77] = t39;
    $[78] = t41;
    $[79] = t42;
  } else {
    t42 = $[79];
  }
  let t43;
  if ($[80] !== t33 || $[81] !== t42) {
    t43 = {
      title: t33,
      content: t42
    };
    $[80] = t33;
    $[81] = t42;
    $[82] = t43;
  } else {
    t43 = $[82];
  }
  let t44;
  if ($[83] !== t) {
    t44 = t("seoCreditCard:sections.5.title");
    $[83] = t;
    $[84] = t44;
  } else {
    t44 = $[84];
  }
  let t45;
  if ($[85] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[85] = t45;
  } else {
    t45 = $[85];
  }
  let t46;
  if ($[86] !== t) {
    t46 = <Trans t={t} i18nKey="seoCreditCard:sections.5.content" components={t45} />;
    $[86] = t;
    $[87] = t46;
  } else {
    t46 = $[87];
  }
  let t47;
  if ($[88] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = {
      subheader: <SubHeader />
    };
    $[88] = t47;
  } else {
    t47 = $[88];
  }
  let t48;
  if ($[89] !== t) {
    t48 = <Trans t={t} i18nKey="seoCreditCard:sections.5.subtitle1" components={t47} />;
    $[89] = t;
    $[90] = t48;
  } else {
    t48 = $[90];
  }
  let t49;
  if ($[91] === Symbol.for("react.memo_cache_sentinel")) {
    t49 = [...Array(6)];
    $[91] = t49;
  } else {
    t49 = $[91];
  }
  let t50;
  if ($[92] !== t) {
    t50 = <PropsConsList items={t49.map((__3, i_2) => {
      const transIndex_2 = i_2 + 1 as NumericRange<1, 6>;
      return <Trans key={i_2} t={t} i18nKey={`seoCreditCard:sections.5.props.${transIndex_2}`} />;
    })} variant="props" className="mt-2" />;
    $[92] = t;
    $[93] = t50;
  } else {
    t50 = $[93];
  }
  let t51;
  if ($[94] === Symbol.for("react.memo_cache_sentinel")) {
    t51 = {
      subheader: <SubHeader />
    };
    $[94] = t51;
  } else {
    t51 = $[94];
  }
  let t52;
  if ($[95] !== t) {
    t52 = <Trans t={t} i18nKey="seoCreditCard:sections.5.subtitle2" components={t51} />;
    $[95] = t;
    $[96] = t52;
  } else {
    t52 = $[96];
  }
  let t53;
  if ($[97] === Symbol.for("react.memo_cache_sentinel")) {
    t53 = [...Array(5)];
    $[97] = t53;
  } else {
    t53 = $[97];
  }
  let t54;
  if ($[98] !== t) {
    t54 = <PropsConsList items={t53.map((__4, i_3) => {
      const transIndex_3 = i_3 + 1 as NumericRange<1, 5>;
      return <Trans key={i_3} t={t} i18nKey={`seoCreditCard:sections.5.cons.${transIndex_3}`} />;
    })} variant="cons" className="mt-2" />;
    $[98] = t;
    $[99] = t54;
  } else {
    t54 = $[99];
  }
  let t55;
  if ($[100] !== t46 || $[101] !== t48 || $[102] !== t50 || $[103] !== t52 || $[104] !== t54) {
    t55 = <>{t46}{t48}{t50}{t52}{t54}</>;
    $[100] = t46;
    $[101] = t48;
    $[102] = t50;
    $[103] = t52;
    $[104] = t54;
    $[105] = t55;
  } else {
    t55 = $[105];
  }
  let t56;
  if ($[106] !== t44 || $[107] !== t55) {
    t56 = {
      title: t44,
      content: t55
    };
    $[106] = t44;
    $[107] = t55;
    $[108] = t56;
  } else {
    t56 = $[108];
  }
  let t57;
  if ($[109] !== t) {
    t57 = t("seoCreditCard:sections.6.title");
    $[109] = t;
    $[110] = t57;
  } else {
    t57 = $[110];
  }
  let t58;
  if ($[111] === Symbol.for("react.memo_cache_sentinel")) {
    t58 = {
      subheader: <SubHeader />
    };
    $[111] = t58;
  } else {
    t58 = $[111];
  }
  let t59;
  if ($[112] !== t) {
    t59 = <Trans t={t} i18nKey="seoCreditCard:sections.6.subtitle1" components={t58} />;
    $[112] = t;
    $[113] = t59;
  } else {
    t59 = $[113];
  }
  let t60;
  if ($[114] === Symbol.for("react.memo_cache_sentinel")) {
    t60 = [...Array(5)];
    $[114] = t60;
  } else {
    t60 = $[114];
  }
  let t61;
  if ($[115] !== t) {
    t61 = <PropsConsList items={t60.map((__5, i_4) => {
      const transIndex_4 = i_4 + 1 as NumericRange<1, 5>;
      return <Trans key={i_4} t={t} i18nKey={`seoCreditCard:sections.6.props.${transIndex_4}`} />;
    })} variant="props" className="mt-2" />;
    $[115] = t;
    $[116] = t61;
  } else {
    t61 = $[116];
  }
  let t62;
  if ($[117] === Symbol.for("react.memo_cache_sentinel")) {
    t62 = {
      subheader: <SubHeader />
    };
    $[117] = t62;
  } else {
    t62 = $[117];
  }
  let t63;
  if ($[118] !== t) {
    t63 = <Trans t={t} i18nKey="seoCreditCard:sections.6.subtitle2" components={t62} />;
    $[118] = t;
    $[119] = t63;
  } else {
    t63 = $[119];
  }
  let t64;
  if ($[120] === Symbol.for("react.memo_cache_sentinel")) {
    t64 = [...Array(4)];
    $[120] = t64;
  } else {
    t64 = $[120];
  }
  let t65;
  if ($[121] !== t) {
    t65 = <PropsConsList items={t64.map((__6, i_5) => {
      const transIndex_5 = i_5 + 1 as NumericRange<1, 4>;
      return <Trans key={i_5} t={t} i18nKey={`seoCreditCard:sections.6.cons.${transIndex_5}`} />;
    })} variant="cons" className="mt-2" />;
    $[121] = t;
    $[122] = t65;
  } else {
    t65 = $[122];
  }
  let t66;
  if ($[123] !== t59 || $[124] !== t61 || $[125] !== t63 || $[126] !== t65) {
    t66 = <>{t59}{t61}{t63}{t65}</>;
    $[123] = t59;
    $[124] = t61;
    $[125] = t63;
    $[126] = t65;
    $[127] = t66;
  } else {
    t66 = $[127];
  }
  let t67;
  if ($[128] !== t57 || $[129] !== t66) {
    t67 = {
      title: t57,
      content: t66
    };
    $[128] = t57;
    $[129] = t66;
    $[130] = t67;
  } else {
    t67 = $[130];
  }
  let t68;
  if ($[131] !== t) {
    t68 = t("seoCreditCard:sections.7.title");
    $[131] = t;
    $[132] = t68;
  } else {
    t68 = $[132];
  }
  let t69;
  if ($[133] === Symbol.for("react.memo_cache_sentinel")) {
    t69 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[133] = t69;
  } else {
    t69 = $[133];
  }
  let t70;
  if ($[134] !== t) {
    t70 = <Trans t={t} i18nKey="seoCreditCard:sections.7.content1" components={t69} />;
    $[134] = t;
    $[135] = t70;
  } else {
    t70 = $[135];
  }
  let t71;
  if ($[136] === Symbol.for("react.memo_cache_sentinel")) {
    t71 = [...Array(7)];
    $[136] = t71;
  } else {
    t71 = $[136];
  }
  let t72;
  if ($[137] !== t) {
    t72 = <UnorderedList items={t71.map((__7, i_6) => {
      const transIndex_6 = i_6 + 1 as NumericRange<1, 7>;
      return <Trans key={i_6} t={t} i18nKey={`seoCreditCard:sections.7.list.${transIndex_6}`} />;
    })} className="mb-4" />;
    $[137] = t;
    $[138] = t72;
  } else {
    t72 = $[138];
  }
  let t73;
  if ($[139] === Symbol.for("react.memo_cache_sentinel")) {
    t73 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[139] = t73;
  } else {
    t73 = $[139];
  }
  let t74;
  if ($[140] !== t) {
    t74 = <Trans t={t} i18nKey="seoCreditCard:sections.7.content2" components={t73} />;
    $[140] = t;
    $[141] = t74;
  } else {
    t74 = $[141];
  }
  let t75;
  if ($[142] === Symbol.for("react.memo_cache_sentinel")) {
    t75 = {
      subheader: <SubHeader />
    };
    $[142] = t75;
  } else {
    t75 = $[142];
  }
  let t76;
  if ($[143] !== t) {
    t76 = <Trans t={t} i18nKey="seoCreditCard:sections.7.subtitle" components={t75} />;
    $[143] = t;
    $[144] = t76;
  } else {
    t76 = $[144];
  }
  let t77;
  if ($[145] === Symbol.for("react.memo_cache_sentinel")) {
    t77 = {
      paragraph: <Paragraph />
    };
    $[145] = t77;
  } else {
    t77 = $[145];
  }
  let t78;
  if ($[146] !== t) {
    t78 = <Trans t={t} i18nKey="seoCreditCard:sections.7.content3" components={t77} />;
    $[146] = t;
    $[147] = t78;
  } else {
    t78 = $[147];
  }
  let t79;
  if ($[148] !== t70 || $[149] !== t72 || $[150] !== t74 || $[151] !== t76 || $[152] !== t78) {
    t79 = <>{t70}{t72}{t74}{t76}{t78}</>;
    $[148] = t70;
    $[149] = t72;
    $[150] = t74;
    $[151] = t76;
    $[152] = t78;
    $[153] = t79;
  } else {
    t79 = $[153];
  }
  let t80;
  if ($[154] !== t68 || $[155] !== t79) {
    t80 = {
      title: t68,
      content: t79
    };
    $[154] = t68;
    $[155] = t79;
    $[156] = t80;
  } else {
    t80 = $[156];
  }
  let t81;
  if ($[157] !== t) {
    t81 = t("seoCreditCard:sections.8.title");
    $[157] = t;
    $[158] = t81;
  } else {
    t81 = $[158];
  }
  let t82;
  if ($[159] === Symbol.for("react.memo_cache_sentinel")) {
    t82 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[159] = t82;
  } else {
    t82 = $[159];
  }
  let t83;
  if ($[160] !== t) {
    t83 = <Trans t={t} i18nKey="seoCreditCard:sections.8.content" components={t82} />;
    $[160] = t;
    $[161] = t83;
  } else {
    t83 = $[161];
  }
  let t84;
  if ($[162] === Symbol.for("react.memo_cache_sentinel")) {
    t84 = [...Array(3)];
    $[162] = t84;
  } else {
    t84 = $[162];
  }
  let t85;
  if ($[163] !== t) {
    t85 = <UnorderedList items={t84.map((__8, i_7) => {
      const transIndex_7 = i_7 + 1 as NumericRange<1, 3>;
      return <Trans key={i_7} t={t} i18nKey={`seoCreditCard:sections.8.list.${transIndex_7}`} components={{
        semibold: <SemiBold />
      }} />;
    })} />;
    $[163] = t;
    $[164] = t85;
  } else {
    t85 = $[164];
  }
  let t86;
  if ($[165] !== t83 || $[166] !== t85) {
    t86 = <>{t83}{t85}</>;
    $[165] = t83;
    $[166] = t85;
    $[167] = t86;
  } else {
    t86 = $[167];
  }
  let t87;
  if ($[168] !== t81 || $[169] !== t86) {
    t87 = {
      title: t81,
      content: t86
    };
    $[168] = t81;
    $[169] = t86;
    $[170] = t87;
  } else {
    t87 = $[170];
  }
  let t88;
  if ($[171] !== t) {
    t88 = t("seoCreditCard:sections.9.title");
    $[171] = t;
    $[172] = t88;
  } else {
    t88 = $[172];
  }
  let t89;
  if ($[173] === Symbol.for("react.memo_cache_sentinel")) {
    t89 = {
      paragraph: <Paragraph />
    };
    $[173] = t89;
  } else {
    t89 = $[173];
  }
  let t90;
  if ($[174] !== t) {
    t90 = <Trans t={t} i18nKey="seoCreditCard:sections.9.content1" components={t89} />;
    $[174] = t;
    $[175] = t90;
  } else {
    t90 = $[175];
  }
  let t91;
  if ($[176] !== t) {
    t91 = t("seoCreditCard:sections.9.table.headers.1");
    $[176] = t;
    $[177] = t91;
  } else {
    t91 = $[177];
  }
  let t92;
  if ($[178] !== t91) {
    t92 = <th className="h-16 w-[19.5rem] rounded-tr-none!">{t91}</th>;
    $[178] = t91;
    $[179] = t92;
  } else {
    t92 = $[179];
  }
  let t93;
  if ($[180] !== t) {
    t93 = t("seoCreditCard:sections.9.table.headers.2");
    $[180] = t;
    $[181] = t93;
  } else {
    t93 = $[181];
  }
  let t94;
  if ($[182] !== t93) {
    t94 = <th className="w-28 text-center!">{t93}</th>;
    $[182] = t93;
    $[183] = t94;
  } else {
    t94 = $[183];
  }
  let t95;
  if ($[184] !== t) {
    t95 = t("seoCreditCard:sections.9.table.headers.3");
    $[184] = t;
    $[185] = t95;
  } else {
    t95 = $[185];
  }
  let t96;
  if ($[186] !== t95) {
    t96 = <th className="w-28 text-center!">{t95}</th>;
    $[186] = t95;
    $[187] = t96;
  } else {
    t96 = $[187];
  }
  let t97;
  if ($[188] !== t) {
    t97 = t("seoCreditCard:sections.9.table.headers.4");
    $[188] = t;
    $[189] = t97;
  } else {
    t97 = $[189];
  }
  let t98;
  if ($[190] !== t97) {
    t98 = <th className="w-28 text-center!">{t97}</th>;
    $[190] = t97;
    $[191] = t98;
  } else {
    t98 = $[191];
  }
  let t99;
  if ($[192] !== t) {
    t99 = t("seoCreditCard:sections.9.table.headers.5");
    $[192] = t;
    $[193] = t99;
  } else {
    t99 = $[193];
  }
  let t100;
  if ($[194] !== t99) {
    t100 = <th className="w-28 rounded-tr-md text-center!">{t99}</th>;
    $[194] = t99;
    $[195] = t100;
  } else {
    t100 = $[195];
  }
  let t101;
  if ($[196] !== t100 || $[197] !== t92 || $[198] !== t94 || $[199] !== t96 || $[200] !== t98) {
    t101 = <tr>{t92}{t94}{t96}{t98}{t100}</tr>;
    $[196] = t100;
    $[197] = t92;
    $[198] = t94;
    $[199] = t96;
    $[200] = t98;
    $[201] = t101;
  } else {
    t101 = $[201];
  }
  let t102;
  if ($[202] !== t) {
    t102 = t("seoCreditCard:sections.9.table.rows.1.columns.1");
    $[202] = t;
    $[203] = t102;
  } else {
    t102 = $[203];
  }
  let t103;
  if ($[204] !== t102) {
    t103 = <td className="w-[19.5rem]">{t102}</td>;
    $[204] = t102;
    $[205] = t103;
  } else {
    t103 = $[205];
  }
  let t104;
  if ($[206] !== t) {
    t104 = t("seoCreditCard:sections.9.table.rows.1.columns.2");
    $[206] = t;
    $[207] = t104;
  } else {
    t104 = $[207];
  }
  let t105;
  if ($[208] !== t104) {
    t105 = <td colSpan={4}>{t104}</td>;
    $[208] = t104;
    $[209] = t105;
  } else {
    t105 = $[209];
  }
  let t106;
  if ($[210] !== t103 || $[211] !== t105) {
    t106 = <tr>{t103}{t105}</tr>;
    $[210] = t103;
    $[211] = t105;
    $[212] = t106;
  } else {
    t106 = $[212];
  }
  let t107;
  if ($[213] !== t) {
    t107 = t("seoCreditCard:sections.9.table.rows.2.columns.1");
    $[213] = t;
    $[214] = t107;
  } else {
    t107 = $[214];
  }
  let t108;
  if ($[215] !== t107) {
    t108 = <td className="w-[19.5rem]">{t107}</td>;
    $[215] = t107;
    $[216] = t108;
  } else {
    t108 = $[216];
  }
  let t109;
  if ($[217] !== t) {
    t109 = t("seoCreditCard:sections.9.table.rows.2.columns.2");
    $[217] = t;
    $[218] = t109;
  } else {
    t109 = $[218];
  }
  let t110;
  if ($[219] !== t109) {
    t110 = <td className="w-28">{t109}</td>;
    $[219] = t109;
    $[220] = t110;
  } else {
    t110 = $[220];
  }
  let t111;
  if ($[221] !== t) {
    t111 = t("seoCreditCard:sections.9.table.rows.2.columns.3");
    $[221] = t;
    $[222] = t111;
  } else {
    t111 = $[222];
  }
  let t112;
  if ($[223] !== t111) {
    t112 = <td className="w-28">{t111}</td>;
    $[223] = t111;
    $[224] = t112;
  } else {
    t112 = $[224];
  }
  let t113;
  if ($[225] !== t) {
    t113 = t("seoCreditCard:sections.9.table.rows.2.columns.4");
    $[225] = t;
    $[226] = t113;
  } else {
    t113 = $[226];
  }
  let t114;
  if ($[227] !== t113) {
    t114 = <td className="w-28">{t113}</td>;
    $[227] = t113;
    $[228] = t114;
  } else {
    t114 = $[228];
  }
  let t115;
  if ($[229] !== t) {
    t115 = t("seoCreditCard:sections.9.table.rows.2.columns.5");
    $[229] = t;
    $[230] = t115;
  } else {
    t115 = $[230];
  }
  let t116;
  if ($[231] !== t115) {
    t116 = <td className="w-28">{t115}</td>;
    $[231] = t115;
    $[232] = t116;
  } else {
    t116 = $[232];
  }
  let t117;
  if ($[233] !== t108 || $[234] !== t110 || $[235] !== t112 || $[236] !== t114 || $[237] !== t116) {
    t117 = <tr>{t108}{t110}{t112}{t114}{t116}</tr>;
    $[233] = t108;
    $[234] = t110;
    $[235] = t112;
    $[236] = t114;
    $[237] = t116;
    $[238] = t117;
  } else {
    t117 = $[238];
  }
  let t118;
  if ($[239] !== t) {
    t118 = t("seoCreditCard:sections.9.table.rows.3.columns.1");
    $[239] = t;
    $[240] = t118;
  } else {
    t118 = $[240];
  }
  let t119;
  if ($[241] !== t118) {
    t119 = <td className="w-[19.5rem]">{t118}</td>;
    $[241] = t118;
    $[242] = t119;
  } else {
    t119 = $[242];
  }
  let t120;
  if ($[243] !== t) {
    t120 = t("seoCreditCard:sections.9.table.rows.3.columns.2");
    $[243] = t;
    $[244] = t120;
  } else {
    t120 = $[244];
  }
  let t121;
  if ($[245] !== t120) {
    t121 = <td className="w-28">{t120}</td>;
    $[245] = t120;
    $[246] = t121;
  } else {
    t121 = $[246];
  }
  let t122;
  if ($[247] !== t) {
    t122 = t("seoCreditCard:sections.9.table.rows.3.columns.3");
    $[247] = t;
    $[248] = t122;
  } else {
    t122 = $[248];
  }
  let t123;
  if ($[249] !== t122) {
    t123 = <td className="w-28">{t122}</td>;
    $[249] = t122;
    $[250] = t123;
  } else {
    t123 = $[250];
  }
  let t124;
  if ($[251] !== t) {
    t124 = t("seoCreditCard:sections.9.table.rows.3.columns.4");
    $[251] = t;
    $[252] = t124;
  } else {
    t124 = $[252];
  }
  let t125;
  if ($[253] !== t124) {
    t125 = <td className="w-28">{t124}</td>;
    $[253] = t124;
    $[254] = t125;
  } else {
    t125 = $[254];
  }
  let t126;
  if ($[255] !== t) {
    t126 = t("seoCreditCard:sections.9.table.rows.3.columns.5");
    $[255] = t;
    $[256] = t126;
  } else {
    t126 = $[256];
  }
  let t127;
  if ($[257] !== t126) {
    t127 = <td className="w-28">{t126}</td>;
    $[257] = t126;
    $[258] = t127;
  } else {
    t127 = $[258];
  }
  let t128;
  if ($[259] !== t119 || $[260] !== t121 || $[261] !== t123 || $[262] !== t125 || $[263] !== t127) {
    t128 = <tr>{t119}{t121}{t123}{t125}{t127}</tr>;
    $[259] = t119;
    $[260] = t121;
    $[261] = t123;
    $[262] = t125;
    $[263] = t127;
    $[264] = t128;
  } else {
    t128 = $[264];
  }
  let t129;
  if ($[265] !== t) {
    t129 = t("seoCreditCard:sections.9.table.rows.4.columns.1");
    $[265] = t;
    $[266] = t129;
  } else {
    t129 = $[266];
  }
  let t130;
  if ($[267] !== t129) {
    t130 = <td className="w-[19.5rem]">{t129}</td>;
    $[267] = t129;
    $[268] = t130;
  } else {
    t130 = $[268];
  }
  let t131;
  if ($[269] !== t) {
    t131 = t("seoCreditCard:sections.9.table.rows.4.columns.2");
    $[269] = t;
    $[270] = t131;
  } else {
    t131 = $[270];
  }
  let t132;
  if ($[271] !== t131) {
    t132 = <td className="w-28">{t131}</td>;
    $[271] = t131;
    $[272] = t132;
  } else {
    t132 = $[272];
  }
  let t133;
  if ($[273] !== t) {
    t133 = t("seoCreditCard:sections.9.table.rows.4.columns.3");
    $[273] = t;
    $[274] = t133;
  } else {
    t133 = $[274];
  }
  let t134;
  if ($[275] !== t133) {
    t134 = <td className="w-28">{t133}</td>;
    $[275] = t133;
    $[276] = t134;
  } else {
    t134 = $[276];
  }
  let t135;
  if ($[277] !== t) {
    t135 = t("seoCreditCard:sections.9.table.rows.4.columns.4");
    $[277] = t;
    $[278] = t135;
  } else {
    t135 = $[278];
  }
  let t136;
  if ($[279] !== t135) {
    t136 = <td className="w-28">{t135}</td>;
    $[279] = t135;
    $[280] = t136;
  } else {
    t136 = $[280];
  }
  let t137;
  if ($[281] !== t) {
    t137 = t("seoCreditCard:sections.9.table.rows.4.columns.5");
    $[281] = t;
    $[282] = t137;
  } else {
    t137 = $[282];
  }
  let t138;
  if ($[283] !== t137) {
    t138 = <td className="w-28">{t137}</td>;
    $[283] = t137;
    $[284] = t138;
  } else {
    t138 = $[284];
  }
  let t139;
  if ($[285] !== t130 || $[286] !== t132 || $[287] !== t134 || $[288] !== t136 || $[289] !== t138) {
    t139 = <tr>{t130}{t132}{t134}{t136}{t138}</tr>;
    $[285] = t130;
    $[286] = t132;
    $[287] = t134;
    $[288] = t136;
    $[289] = t138;
    $[290] = t139;
  } else {
    t139 = $[290];
  }
  let t140;
  if ($[291] !== t) {
    t140 = t("seoCreditCard:sections.9.table.rows.5.columns.1");
    $[291] = t;
    $[292] = t140;
  } else {
    t140 = $[292];
  }
  let t141;
  if ($[293] !== t140) {
    t141 = <td className="w-[19.5rem]">{t140}</td>;
    $[293] = t140;
    $[294] = t141;
  } else {
    t141 = $[294];
  }
  let t142;
  if ($[295] !== t) {
    t142 = t("seoCreditCard:sections.9.table.rows.5.columns.2");
    $[295] = t;
    $[296] = t142;
  } else {
    t142 = $[296];
  }
  let t143;
  if ($[297] !== t142) {
    t143 = <td className="w-28">{t142}</td>;
    $[297] = t142;
    $[298] = t143;
  } else {
    t143 = $[298];
  }
  let t144;
  if ($[299] !== t) {
    t144 = t("seoCreditCard:sections.9.table.rows.5.columns.3");
    $[299] = t;
    $[300] = t144;
  } else {
    t144 = $[300];
  }
  let t145;
  if ($[301] !== t144) {
    t145 = <td className="w-28">{t144}</td>;
    $[301] = t144;
    $[302] = t145;
  } else {
    t145 = $[302];
  }
  let t146;
  if ($[303] !== t) {
    t146 = t("seoCreditCard:sections.9.table.rows.5.columns.4");
    $[303] = t;
    $[304] = t146;
  } else {
    t146 = $[304];
  }
  let t147;
  if ($[305] !== t146) {
    t147 = <td className="w-28">{t146}</td>;
    $[305] = t146;
    $[306] = t147;
  } else {
    t147 = $[306];
  }
  let t148;
  if ($[307] !== t) {
    t148 = t("seoCreditCard:sections.9.table.rows.5.columns.5");
    $[307] = t;
    $[308] = t148;
  } else {
    t148 = $[308];
  }
  let t149;
  if ($[309] !== t148) {
    t149 = <td className="w-28">{t148}</td>;
    $[309] = t148;
    $[310] = t149;
  } else {
    t149 = $[310];
  }
  let t150;
  if ($[311] !== t141 || $[312] !== t143 || $[313] !== t145 || $[314] !== t147 || $[315] !== t149) {
    t150 = <tr>{t141}{t143}{t145}{t147}{t149}</tr>;
    $[311] = t141;
    $[312] = t143;
    $[313] = t145;
    $[314] = t147;
    $[315] = t149;
    $[316] = t150;
  } else {
    t150 = $[316];
  }
  let t151;
  if ($[317] !== t) {
    t151 = t("seoCreditCard:sections.9.table.rows.6.columns.1");
    $[317] = t;
    $[318] = t151;
  } else {
    t151 = $[318];
  }
  let t152;
  if ($[319] !== t151) {
    t152 = <td className="w-[19.5rem]">{t151}</td>;
    $[319] = t151;
    $[320] = t152;
  } else {
    t152 = $[320];
  }
  let t153;
  if ($[321] !== t) {
    t153 = t("seoCreditCard:sections.9.table.rows.6.columns.2");
    $[321] = t;
    $[322] = t153;
  } else {
    t153 = $[322];
  }
  let t154;
  if ($[323] !== t153) {
    t154 = <td colSpan={4}>{t153}</td>;
    $[323] = t153;
    $[324] = t154;
  } else {
    t154 = $[324];
  }
  let t155;
  if ($[325] !== t152 || $[326] !== t154) {
    t155 = <tr>{t152}{t154}</tr>;
    $[325] = t152;
    $[326] = t154;
    $[327] = t155;
  } else {
    t155 = $[327];
  }
  let t156;
  if ($[328] !== t) {
    t156 = t("seoCreditCard:sections.9.table.rows.7.columns.1");
    $[328] = t;
    $[329] = t156;
  } else {
    t156 = $[329];
  }
  let t157;
  if ($[330] !== t156) {
    t157 = <td className="w-[19.5rem]">{t156}</td>;
    $[330] = t156;
    $[331] = t157;
  } else {
    t157 = $[331];
  }
  let t158;
  if ($[332] !== t) {
    t158 = t("seoCreditCard:sections.9.table.rows.7.columns.2");
    $[332] = t;
    $[333] = t158;
  } else {
    t158 = $[333];
  }
  let t159;
  if ($[334] !== t158) {
    t159 = <td className="w-28">{t158}</td>;
    $[334] = t158;
    $[335] = t159;
  } else {
    t159 = $[335];
  }
  let t160;
  if ($[336] !== t) {
    t160 = t("seoCreditCard:sections.9.table.rows.7.columns.3");
    $[336] = t;
    $[337] = t160;
  } else {
    t160 = $[337];
  }
  let t161;
  if ($[338] !== t160) {
    t161 = <td className="w-28">{t160}</td>;
    $[338] = t160;
    $[339] = t161;
  } else {
    t161 = $[339];
  }
  let t162;
  if ($[340] !== t) {
    t162 = t("seoCreditCard:sections.9.table.rows.7.columns.4");
    $[340] = t;
    $[341] = t162;
  } else {
    t162 = $[341];
  }
  let t163;
  if ($[342] !== t162) {
    t163 = <td className="w-28">{t162}</td>;
    $[342] = t162;
    $[343] = t163;
  } else {
    t163 = $[343];
  }
  let t164;
  if ($[344] !== t) {
    t164 = t("seoCreditCard:sections.9.table.rows.7.columns.5");
    $[344] = t;
    $[345] = t164;
  } else {
    t164 = $[345];
  }
  let t165;
  if ($[346] !== t164) {
    t165 = <td className="w-28">{t164}</td>;
    $[346] = t164;
    $[347] = t165;
  } else {
    t165 = $[347];
  }
  let t166;
  if ($[348] !== t157 || $[349] !== t159 || $[350] !== t161 || $[351] !== t163 || $[352] !== t165) {
    t166 = <tr>{t157}{t159}{t161}{t163}{t165}</tr>;
    $[348] = t157;
    $[349] = t159;
    $[350] = t161;
    $[351] = t163;
    $[352] = t165;
    $[353] = t166;
  } else {
    t166 = $[353];
  }
  let t167;
  if ($[354] !== t) {
    t167 = t("seoCreditCard:sections.9.table.rows.8.columns.1");
    $[354] = t;
    $[355] = t167;
  } else {
    t167 = $[355];
  }
  let t168;
  if ($[356] !== t167) {
    t168 = <td className="w-[19.5rem]">{t167}</td>;
    $[356] = t167;
    $[357] = t168;
  } else {
    t168 = $[357];
  }
  let t169;
  if ($[358] !== t) {
    t169 = t("seoCreditCard:sections.9.table.rows.8.columns.2");
    $[358] = t;
    $[359] = t169;
  } else {
    t169 = $[359];
  }
  let t170;
  if ($[360] !== t169) {
    t170 = <td className="w-28">{t169}</td>;
    $[360] = t169;
    $[361] = t170;
  } else {
    t170 = $[361];
  }
  let t171;
  if ($[362] !== t) {
    t171 = t("seoCreditCard:sections.9.table.rows.8.columns.3");
    $[362] = t;
    $[363] = t171;
  } else {
    t171 = $[363];
  }
  let t172;
  if ($[364] !== t171) {
    t172 = <td className="w-28">{t171}</td>;
    $[364] = t171;
    $[365] = t172;
  } else {
    t172 = $[365];
  }
  let t173;
  if ($[366] !== t) {
    t173 = t("seoCreditCard:sections.9.table.rows.8.columns.4");
    $[366] = t;
    $[367] = t173;
  } else {
    t173 = $[367];
  }
  let t174;
  if ($[368] !== t173) {
    t174 = <td className="w-28">{t173}</td>;
    $[368] = t173;
    $[369] = t174;
  } else {
    t174 = $[369];
  }
  let t175;
  if ($[370] !== t) {
    t175 = t("seoCreditCard:sections.9.table.rows.8.columns.5");
    $[370] = t;
    $[371] = t175;
  } else {
    t175 = $[371];
  }
  let t176;
  if ($[372] !== t175) {
    t176 = <td className="w-28">{t175}</td>;
    $[372] = t175;
    $[373] = t176;
  } else {
    t176 = $[373];
  }
  let t177;
  if ($[374] !== t168 || $[375] !== t170 || $[376] !== t172 || $[377] !== t174 || $[378] !== t176) {
    t177 = <tr>{t168}{t170}{t172}{t174}{t176}</tr>;
    $[374] = t168;
    $[375] = t170;
    $[376] = t172;
    $[377] = t174;
    $[378] = t176;
    $[379] = t177;
  } else {
    t177 = $[379];
  }
  let t178;
  if ($[380] !== t) {
    t178 = t("seoCreditCard:sections.9.table.rows.9.columns.1");
    $[380] = t;
    $[381] = t178;
  } else {
    t178 = $[381];
  }
  let t179;
  if ($[382] !== t178) {
    t179 = <td className="w-[19.5rem]">{t178}</td>;
    $[382] = t178;
    $[383] = t179;
  } else {
    t179 = $[383];
  }
  let t180;
  if ($[384] !== t) {
    t180 = t("seoCreditCard:sections.9.table.rows.9.columns.2");
    $[384] = t;
    $[385] = t180;
  } else {
    t180 = $[385];
  }
  let t181;
  if ($[386] !== t180) {
    t181 = <td className="w-28">{t180}</td>;
    $[386] = t180;
    $[387] = t181;
  } else {
    t181 = $[387];
  }
  let t182;
  if ($[388] !== t) {
    t182 = t("seoCreditCard:sections.9.table.rows.9.columns.3");
    $[388] = t;
    $[389] = t182;
  } else {
    t182 = $[389];
  }
  let t183;
  if ($[390] !== t182) {
    t183 = <td className="w-28">{t182}</td>;
    $[390] = t182;
    $[391] = t183;
  } else {
    t183 = $[391];
  }
  let t184;
  if ($[392] !== t) {
    t184 = t("seoCreditCard:sections.9.table.rows.9.columns.4");
    $[392] = t;
    $[393] = t184;
  } else {
    t184 = $[393];
  }
  let t185;
  if ($[394] !== t184) {
    t185 = <td className="w-28">{t184}</td>;
    $[394] = t184;
    $[395] = t185;
  } else {
    t185 = $[395];
  }
  let t186;
  if ($[396] !== t) {
    t186 = t("seoCreditCard:sections.9.table.rows.9.columns.5");
    $[396] = t;
    $[397] = t186;
  } else {
    t186 = $[397];
  }
  let t187;
  if ($[398] !== t186) {
    t187 = <td className="w-28">{t186}</td>;
    $[398] = t186;
    $[399] = t187;
  } else {
    t187 = $[399];
  }
  let t188;
  if ($[400] !== t179 || $[401] !== t181 || $[402] !== t183 || $[403] !== t185 || $[404] !== t187) {
    t188 = <tr>{t179}{t181}{t183}{t185}{t187}</tr>;
    $[400] = t179;
    $[401] = t181;
    $[402] = t183;
    $[403] = t185;
    $[404] = t187;
    $[405] = t188;
  } else {
    t188 = $[405];
  }
  let t189;
  if ($[406] !== t) {
    t189 = t("seoCreditCard:sections.9.table.rows.10.columns.1");
    $[406] = t;
    $[407] = t189;
  } else {
    t189 = $[407];
  }
  let t190;
  if ($[408] !== t189) {
    t190 = <td className="w-[19.5rem]">{t189}</td>;
    $[408] = t189;
    $[409] = t190;
  } else {
    t190 = $[409];
  }
  let t191;
  if ($[410] !== t) {
    t191 = t("seoCreditCard:sections.9.table.rows.10.columns.2");
    $[410] = t;
    $[411] = t191;
  } else {
    t191 = $[411];
  }
  let t192;
  if ($[412] !== t191) {
    t192 = <td className="w-28">{t191}</td>;
    $[412] = t191;
    $[413] = t192;
  } else {
    t192 = $[413];
  }
  let t193;
  if ($[414] !== t) {
    t193 = t("seoCreditCard:sections.9.table.rows.10.columns.3");
    $[414] = t;
    $[415] = t193;
  } else {
    t193 = $[415];
  }
  let t194;
  if ($[416] !== t193) {
    t194 = <td className="w-28">{t193}</td>;
    $[416] = t193;
    $[417] = t194;
  } else {
    t194 = $[417];
  }
  let t195;
  if ($[418] !== t) {
    t195 = t("seoCreditCard:sections.9.table.rows.10.columns.4");
    $[418] = t;
    $[419] = t195;
  } else {
    t195 = $[419];
  }
  let t196;
  if ($[420] !== t195) {
    t196 = <td className="w-28">{t195}</td>;
    $[420] = t195;
    $[421] = t196;
  } else {
    t196 = $[421];
  }
  let t197;
  if ($[422] !== t) {
    t197 = t("seoCreditCard:sections.9.table.rows.10.columns.5");
    $[422] = t;
    $[423] = t197;
  } else {
    t197 = $[423];
  }
  let t198;
  if ($[424] !== t197) {
    t198 = <td className="w-28">{t197}</td>;
    $[424] = t197;
    $[425] = t198;
  } else {
    t198 = $[425];
  }
  let t199;
  if ($[426] !== t190 || $[427] !== t192 || $[428] !== t194 || $[429] !== t196 || $[430] !== t198) {
    t199 = <tr>{t190}{t192}{t194}{t196}{t198}</tr>;
    $[426] = t190;
    $[427] = t192;
    $[428] = t194;
    $[429] = t196;
    $[430] = t198;
    $[431] = t199;
  } else {
    t199 = $[431];
  }
  let t200;
  if ($[432] !== t) {
    t200 = t("seoCreditCard:sections.9.table.rows.11.columns.1");
    $[432] = t;
    $[433] = t200;
  } else {
    t200 = $[433];
  }
  let t201;
  if ($[434] !== t200) {
    t201 = <td className="w-[19.5rem]">{t200}</td>;
    $[434] = t200;
    $[435] = t201;
  } else {
    t201 = $[435];
  }
  let t202;
  if ($[436] !== t) {
    t202 = t("seoCreditCard:sections.9.table.rows.11.columns.2");
    $[436] = t;
    $[437] = t202;
  } else {
    t202 = $[437];
  }
  let t203;
  if ($[438] !== t202) {
    t203 = <td className="w-28">{t202}</td>;
    $[438] = t202;
    $[439] = t203;
  } else {
    t203 = $[439];
  }
  let t204;
  if ($[440] !== t) {
    t204 = t("seoCreditCard:sections.9.table.rows.11.columns.3");
    $[440] = t;
    $[441] = t204;
  } else {
    t204 = $[441];
  }
  let t205;
  if ($[442] !== t204) {
    t205 = <td className="w-28">{t204}</td>;
    $[442] = t204;
    $[443] = t205;
  } else {
    t205 = $[443];
  }
  let t206;
  if ($[444] !== t) {
    t206 = t("seoCreditCard:sections.9.table.rows.11.columns.4");
    $[444] = t;
    $[445] = t206;
  } else {
    t206 = $[445];
  }
  let t207;
  if ($[446] !== t206) {
    t207 = <td className="w-28">{t206}</td>;
    $[446] = t206;
    $[447] = t207;
  } else {
    t207 = $[447];
  }
  let t208;
  if ($[448] !== t) {
    t208 = t("seoCreditCard:sections.9.table.rows.11.columns.5");
    $[448] = t;
    $[449] = t208;
  } else {
    t208 = $[449];
  }
  let t209;
  if ($[450] !== t208) {
    t209 = <td className="w-28">{t208}</td>;
    $[450] = t208;
    $[451] = t209;
  } else {
    t209 = $[451];
  }
  let t210;
  if ($[452] !== t201 || $[453] !== t203 || $[454] !== t205 || $[455] !== t207 || $[456] !== t209) {
    t210 = <tr>{t201}{t203}{t205}{t207}{t209}</tr>;
    $[452] = t201;
    $[453] = t203;
    $[454] = t205;
    $[455] = t207;
    $[456] = t209;
    $[457] = t210;
  } else {
    t210 = $[457];
  }
  let t211;
  if ($[458] !== t) {
    t211 = t("seoCreditCard:sections.9.table.rows.12.columns.1");
    $[458] = t;
    $[459] = t211;
  } else {
    t211 = $[459];
  }
  let t212;
  if ($[460] !== t211) {
    t212 = <td className="w-[19.5rem]">{t211}</td>;
    $[460] = t211;
    $[461] = t212;
  } else {
    t212 = $[461];
  }
  let t213;
  if ($[462] !== t) {
    t213 = t("seoCreditCard:sections.9.table.rows.12.columns.2");
    $[462] = t;
    $[463] = t213;
  } else {
    t213 = $[463];
  }
  let t214;
  if ($[464] !== t213) {
    t214 = <td className="w-28">{t213}</td>;
    $[464] = t213;
    $[465] = t214;
  } else {
    t214 = $[465];
  }
  let t215;
  if ($[466] !== t) {
    t215 = t("seoCreditCard:sections.9.table.rows.12.columns.3");
    $[466] = t;
    $[467] = t215;
  } else {
    t215 = $[467];
  }
  let t216;
  if ($[468] !== t215) {
    t216 = <td className="w-28">{t215}</td>;
    $[468] = t215;
    $[469] = t216;
  } else {
    t216 = $[469];
  }
  let t217;
  if ($[470] !== t) {
    t217 = t("seoCreditCard:sections.9.table.rows.12.columns.4");
    $[470] = t;
    $[471] = t217;
  } else {
    t217 = $[471];
  }
  let t218;
  if ($[472] !== t217) {
    t218 = <td className="w-28">{t217}</td>;
    $[472] = t217;
    $[473] = t218;
  } else {
    t218 = $[473];
  }
  let t219;
  if ($[474] !== t) {
    t219 = t("seoCreditCard:sections.9.table.rows.12.columns.5");
    $[474] = t;
    $[475] = t219;
  } else {
    t219 = $[475];
  }
  let t220;
  if ($[476] !== t219) {
    t220 = <td className="w-28">{t219}</td>;
    $[476] = t219;
    $[477] = t220;
  } else {
    t220 = $[477];
  }
  let t221;
  if ($[478] !== t212 || $[479] !== t214 || $[480] !== t216 || $[481] !== t218 || $[482] !== t220) {
    t221 = <tr>{t212}{t214}{t216}{t218}{t220}</tr>;
    $[478] = t212;
    $[479] = t214;
    $[480] = t216;
    $[481] = t218;
    $[482] = t220;
    $[483] = t221;
  } else {
    t221 = $[483];
  }
  let t222;
  if ($[484] !== t) {
    t222 = t("seoCreditCard:sections.9.table.rows.13.columns.1");
    $[484] = t;
    $[485] = t222;
  } else {
    t222 = $[485];
  }
  let t223;
  if ($[486] !== t222) {
    t223 = <td className="w-[19.5rem]">{t222}</td>;
    $[486] = t222;
    $[487] = t223;
  } else {
    t223 = $[487];
  }
  let t224;
  if ($[488] !== t) {
    t224 = t("seoCreditCard:sections.9.table.rows.13.columns.2");
    $[488] = t;
    $[489] = t224;
  } else {
    t224 = $[489];
  }
  let t225;
  if ($[490] !== t224) {
    t225 = <td className="w-28">{t224}</td>;
    $[490] = t224;
    $[491] = t225;
  } else {
    t225 = $[491];
  }
  let t226;
  if ($[492] !== t) {
    t226 = t("seoCreditCard:sections.9.table.rows.13.columns.3");
    $[492] = t;
    $[493] = t226;
  } else {
    t226 = $[493];
  }
  let t227;
  if ($[494] !== t226) {
    t227 = <td className="w-28">{t226}</td>;
    $[494] = t226;
    $[495] = t227;
  } else {
    t227 = $[495];
  }
  let t228;
  if ($[496] !== t) {
    t228 = t("seoCreditCard:sections.9.table.rows.13.columns.4");
    $[496] = t;
    $[497] = t228;
  } else {
    t228 = $[497];
  }
  let t229;
  if ($[498] !== t228) {
    t229 = <td className="w-28">{t228}</td>;
    $[498] = t228;
    $[499] = t229;
  } else {
    t229 = $[499];
  }
  let t230;
  if ($[500] !== t) {
    t230 = t("seoCreditCard:sections.9.table.rows.13.columns.5");
    $[500] = t;
    $[501] = t230;
  } else {
    t230 = $[501];
  }
  let t231;
  if ($[502] !== t230) {
    t231 = <td className="w-28">{t230}</td>;
    $[502] = t230;
    $[503] = t231;
  } else {
    t231 = $[503];
  }
  let t232;
  if ($[504] !== t223 || $[505] !== t225 || $[506] !== t227 || $[507] !== t229 || $[508] !== t231) {
    t232 = <tr>{t223}{t225}{t227}{t229}{t231}</tr>;
    $[504] = t223;
    $[505] = t225;
    $[506] = t227;
    $[507] = t229;
    $[508] = t231;
    $[509] = t232;
  } else {
    t232 = $[509];
  }
  let t233;
  if ($[510] !== t) {
    t233 = t("seoCreditCard:sections.9.table.rows.14.columns.1");
    $[510] = t;
    $[511] = t233;
  } else {
    t233 = $[511];
  }
  let t234;
  if ($[512] !== t233) {
    t234 = <td className="w-[19.5rem]">{t233}</td>;
    $[512] = t233;
    $[513] = t234;
  } else {
    t234 = $[513];
  }
  let t235;
  if ($[514] !== t) {
    t235 = t("seoCreditCard:sections.9.table.rows.14.columns.2");
    $[514] = t;
    $[515] = t235;
  } else {
    t235 = $[515];
  }
  let t236;
  if ($[516] !== t235) {
    t236 = <td className="w-28">{t235}</td>;
    $[516] = t235;
    $[517] = t236;
  } else {
    t236 = $[517];
  }
  let t237;
  if ($[518] !== t) {
    t237 = t("seoCreditCard:sections.9.table.rows.14.columns.3");
    $[518] = t;
    $[519] = t237;
  } else {
    t237 = $[519];
  }
  let t238;
  if ($[520] !== t237) {
    t238 = <td className="w-28">{t237}</td>;
    $[520] = t237;
    $[521] = t238;
  } else {
    t238 = $[521];
  }
  let t239;
  if ($[522] !== t) {
    t239 = t("seoCreditCard:sections.9.table.rows.14.columns.4");
    $[522] = t;
    $[523] = t239;
  } else {
    t239 = $[523];
  }
  let t240;
  if ($[524] !== t239) {
    t240 = <td className="w-28">{t239}</td>;
    $[524] = t239;
    $[525] = t240;
  } else {
    t240 = $[525];
  }
  let t241;
  if ($[526] !== t) {
    t241 = t("seoCreditCard:sections.9.table.rows.14.columns.5");
    $[526] = t;
    $[527] = t241;
  } else {
    t241 = $[527];
  }
  let t242;
  if ($[528] !== t241) {
    t242 = <td className="w-28">{t241}</td>;
    $[528] = t241;
    $[529] = t242;
  } else {
    t242 = $[529];
  }
  let t243;
  if ($[530] !== t234 || $[531] !== t236 || $[532] !== t238 || $[533] !== t240 || $[534] !== t242) {
    t243 = <tr>{t234}{t236}{t238}{t240}{t242}</tr>;
    $[530] = t234;
    $[531] = t236;
    $[532] = t238;
    $[533] = t240;
    $[534] = t242;
    $[535] = t243;
  } else {
    t243 = $[535];
  }
  let t244;
  if ($[536] !== t) {
    t244 = t("seoCreditCard:sections.9.table.rows.15.columns.1");
    $[536] = t;
    $[537] = t244;
  } else {
    t244 = $[537];
  }
  let t245;
  if ($[538] !== t244) {
    t245 = <td className="w-[19.5rem]">{t244}</td>;
    $[538] = t244;
    $[539] = t245;
  } else {
    t245 = $[539];
  }
  let t246;
  if ($[540] !== t) {
    t246 = t("seoCreditCard:sections.9.table.rows.15.columns.2");
    $[540] = t;
    $[541] = t246;
  } else {
    t246 = $[541];
  }
  let t247;
  if ($[542] !== t246) {
    t247 = <td className="w-28">{t246}</td>;
    $[542] = t246;
    $[543] = t247;
  } else {
    t247 = $[543];
  }
  let t248;
  if ($[544] !== t) {
    t248 = t("seoCreditCard:sections.9.table.rows.15.columns.3");
    $[544] = t;
    $[545] = t248;
  } else {
    t248 = $[545];
  }
  let t249;
  if ($[546] !== t248) {
    t249 = <td className="w-28">{t248}</td>;
    $[546] = t248;
    $[547] = t249;
  } else {
    t249 = $[547];
  }
  let t250;
  if ($[548] !== t) {
    t250 = t("seoCreditCard:sections.9.table.rows.15.columns.4");
    $[548] = t;
    $[549] = t250;
  } else {
    t250 = $[549];
  }
  let t251;
  if ($[550] !== t250) {
    t251 = <td className="w-28">{t250}</td>;
    $[550] = t250;
    $[551] = t251;
  } else {
    t251 = $[551];
  }
  let t252;
  if ($[552] !== t) {
    t252 = t("seoCreditCard:sections.9.table.rows.15.columns.5");
    $[552] = t;
    $[553] = t252;
  } else {
    t252 = $[553];
  }
  let t253;
  if ($[554] !== t252) {
    t253 = <td className="w-28">{t252}</td>;
    $[554] = t252;
    $[555] = t253;
  } else {
    t253 = $[555];
  }
  let t254;
  if ($[556] !== t245 || $[557] !== t247 || $[558] !== t249 || $[559] !== t251 || $[560] !== t253) {
    t254 = <tr>{t245}{t247}{t249}{t251}{t253}</tr>;
    $[556] = t245;
    $[557] = t247;
    $[558] = t249;
    $[559] = t251;
    $[560] = t253;
    $[561] = t254;
  } else {
    t254 = $[561];
  }
  let t255;
  if ($[562] !== t) {
    t255 = t("seoCreditCard:sections.9.table.rows.16.columns.1");
    $[562] = t;
    $[563] = t255;
  } else {
    t255 = $[563];
  }
  let t256;
  if ($[564] !== t255) {
    t256 = <td className="w-[19.5rem]">{t255}</td>;
    $[564] = t255;
    $[565] = t256;
  } else {
    t256 = $[565];
  }
  let t257;
  if ($[566] !== t) {
    t257 = t("seoCreditCard:sections.9.table.rows.16.columns.2");
    $[566] = t;
    $[567] = t257;
  } else {
    t257 = $[567];
  }
  let t258;
  if ($[568] !== t257) {
    t258 = <td className="w-28">{t257}</td>;
    $[568] = t257;
    $[569] = t258;
  } else {
    t258 = $[569];
  }
  let t259;
  if ($[570] !== t) {
    t259 = t("seoCreditCard:sections.9.table.rows.16.columns.3");
    $[570] = t;
    $[571] = t259;
  } else {
    t259 = $[571];
  }
  let t260;
  if ($[572] !== t259) {
    t260 = <td className="w-28">{t259}</td>;
    $[572] = t259;
    $[573] = t260;
  } else {
    t260 = $[573];
  }
  let t261;
  if ($[574] !== t) {
    t261 = t("seoCreditCard:sections.9.table.rows.16.columns.4");
    $[574] = t;
    $[575] = t261;
  } else {
    t261 = $[575];
  }
  let t262;
  if ($[576] !== t261) {
    t262 = <td className="w-28">{t261}</td>;
    $[576] = t261;
    $[577] = t262;
  } else {
    t262 = $[577];
  }
  let t263;
  if ($[578] !== t) {
    t263 = t("seoCreditCard:sections.9.table.rows.16.columns.5");
    $[578] = t;
    $[579] = t263;
  } else {
    t263 = $[579];
  }
  let t264;
  if ($[580] !== t263) {
    t264 = <td className="w-28">{t263}</td>;
    $[580] = t263;
    $[581] = t264;
  } else {
    t264 = $[581];
  }
  let t265;
  if ($[582] !== t256 || $[583] !== t258 || $[584] !== t260 || $[585] !== t262 || $[586] !== t264) {
    t265 = <tr>{t256}{t258}{t260}{t262}{t264}</tr>;
    $[582] = t256;
    $[583] = t258;
    $[584] = t260;
    $[585] = t262;
    $[586] = t264;
    $[587] = t265;
  } else {
    t265 = $[587];
  }
  let t266;
  if ($[588] !== t) {
    t266 = t("seoCreditCard:sections.9.table.rows.17.columns.1");
    $[588] = t;
    $[589] = t266;
  } else {
    t266 = $[589];
  }
  let t267;
  if ($[590] !== t266) {
    t267 = <td className="w-[19.5rem]">{t266}</td>;
    $[590] = t266;
    $[591] = t267;
  } else {
    t267 = $[591];
  }
  let t268;
  if ($[592] !== t) {
    t268 = t("seoCreditCard:sections.9.table.rows.17.columns.2");
    $[592] = t;
    $[593] = t268;
  } else {
    t268 = $[593];
  }
  let t269;
  if ($[594] !== t268) {
    t269 = <td className="w-28">{t268}</td>;
    $[594] = t268;
    $[595] = t269;
  } else {
    t269 = $[595];
  }
  let t270;
  if ($[596] !== t) {
    t270 = t("seoCreditCard:sections.9.table.rows.17.columns.3");
    $[596] = t;
    $[597] = t270;
  } else {
    t270 = $[597];
  }
  let t271;
  if ($[598] !== t270) {
    t271 = <td className="w-28">{t270}</td>;
    $[598] = t270;
    $[599] = t271;
  } else {
    t271 = $[599];
  }
  let t272;
  if ($[600] !== t) {
    t272 = t("seoCreditCard:sections.9.table.rows.17.columns.4");
    $[600] = t;
    $[601] = t272;
  } else {
    t272 = $[601];
  }
  let t273;
  if ($[602] !== t272) {
    t273 = <td className="w-28">{t272}</td>;
    $[602] = t272;
    $[603] = t273;
  } else {
    t273 = $[603];
  }
  let t274;
  if ($[604] !== t) {
    t274 = t("seoCreditCard:sections.9.table.rows.17.columns.5");
    $[604] = t;
    $[605] = t274;
  } else {
    t274 = $[605];
  }
  let t275;
  if ($[606] !== t274) {
    t275 = <td className="w-28">{t274}</td>;
    $[606] = t274;
    $[607] = t275;
  } else {
    t275 = $[607];
  }
  let t276;
  if ($[608] !== t267 || $[609] !== t269 || $[610] !== t271 || $[611] !== t273 || $[612] !== t275) {
    t276 = <tr>{t267}{t269}{t271}{t273}{t275}</tr>;
    $[608] = t267;
    $[609] = t269;
    $[610] = t271;
    $[611] = t273;
    $[612] = t275;
    $[613] = t276;
  } else {
    t276 = $[613];
  }
  let t277;
  if ($[614] !== t) {
    t277 = t("seoCreditCard:sections.9.table.rows.18.columns.1");
    $[614] = t;
    $[615] = t277;
  } else {
    t277 = $[615];
  }
  let t278;
  if ($[616] !== t277) {
    t278 = <td className="w-[19.5rem]">{t277}</td>;
    $[616] = t277;
    $[617] = t278;
  } else {
    t278 = $[617];
  }
  let t279;
  if ($[618] !== t) {
    t279 = t("seoCreditCard:sections.9.table.rows.18.columns.2");
    $[618] = t;
    $[619] = t279;
  } else {
    t279 = $[619];
  }
  let t280;
  if ($[620] !== t279) {
    t280 = <td className="w-28">{t279}</td>;
    $[620] = t279;
    $[621] = t280;
  } else {
    t280 = $[621];
  }
  let t281;
  if ($[622] !== t) {
    t281 = t("seoCreditCard:sections.9.table.rows.18.columns.3");
    $[622] = t;
    $[623] = t281;
  } else {
    t281 = $[623];
  }
  let t282;
  if ($[624] !== t281) {
    t282 = <td className="w-28">{t281}</td>;
    $[624] = t281;
    $[625] = t282;
  } else {
    t282 = $[625];
  }
  let t283;
  if ($[626] !== t) {
    t283 = t("seoCreditCard:sections.9.table.rows.18.columns.4");
    $[626] = t;
    $[627] = t283;
  } else {
    t283 = $[627];
  }
  let t284;
  if ($[628] !== t283) {
    t284 = <td className="w-28">{t283}</td>;
    $[628] = t283;
    $[629] = t284;
  } else {
    t284 = $[629];
  }
  let t285;
  if ($[630] !== t) {
    t285 = t("seoCreditCard:sections.9.table.rows.18.columns.5");
    $[630] = t;
    $[631] = t285;
  } else {
    t285 = $[631];
  }
  let t286;
  if ($[632] !== t285) {
    t286 = <td className="w-28">{t285}</td>;
    $[632] = t285;
    $[633] = t286;
  } else {
    t286 = $[633];
  }
  let t287;
  if ($[634] !== t278 || $[635] !== t280 || $[636] !== t282 || $[637] !== t284 || $[638] !== t286) {
    t287 = <tr>{t278}{t280}{t282}{t284}{t286}</tr>;
    $[634] = t278;
    $[635] = t280;
    $[636] = t282;
    $[637] = t284;
    $[638] = t286;
    $[639] = t287;
  } else {
    t287 = $[639];
  }
  let t288;
  if ($[640] !== t) {
    t288 = t("seoCreditCard:sections.9.table.rows.19.columns.1");
    $[640] = t;
    $[641] = t288;
  } else {
    t288 = $[641];
  }
  let t289;
  if ($[642] !== t288) {
    t289 = <td className="w-[19.5rem]">{t288}</td>;
    $[642] = t288;
    $[643] = t289;
  } else {
    t289 = $[643];
  }
  let t290;
  if ($[644] !== t) {
    t290 = t("seoCreditCard:sections.9.table.rows.19.columns.2");
    $[644] = t;
    $[645] = t290;
  } else {
    t290 = $[645];
  }
  let t291;
  if ($[646] !== t290) {
    t291 = <td className="w-28">{t290}</td>;
    $[646] = t290;
    $[647] = t291;
  } else {
    t291 = $[647];
  }
  let t292;
  if ($[648] !== t) {
    t292 = t("seoCreditCard:sections.9.table.rows.19.columns.3");
    $[648] = t;
    $[649] = t292;
  } else {
    t292 = $[649];
  }
  let t293;
  if ($[650] !== t292) {
    t293 = <td className="w-28">{t292}</td>;
    $[650] = t292;
    $[651] = t293;
  } else {
    t293 = $[651];
  }
  let t294;
  if ($[652] !== t) {
    t294 = t("seoCreditCard:sections.9.table.rows.19.columns.4");
    $[652] = t;
    $[653] = t294;
  } else {
    t294 = $[653];
  }
  let t295;
  if ($[654] !== t294) {
    t295 = <td className="w-28">{t294}</td>;
    $[654] = t294;
    $[655] = t295;
  } else {
    t295 = $[655];
  }
  let t296;
  if ($[656] !== t) {
    t296 = t("seoCreditCard:sections.9.table.rows.19.columns.5");
    $[656] = t;
    $[657] = t296;
  } else {
    t296 = $[657];
  }
  let t297;
  if ($[658] !== t296) {
    t297 = <td className="w-28">{t296}</td>;
    $[658] = t296;
    $[659] = t297;
  } else {
    t297 = $[659];
  }
  let t298;
  if ($[660] !== t289 || $[661] !== t291 || $[662] !== t293 || $[663] !== t295 || $[664] !== t297) {
    t298 = <tr>{t289}{t291}{t293}{t295}{t297}</tr>;
    $[660] = t289;
    $[661] = t291;
    $[662] = t293;
    $[663] = t295;
    $[664] = t297;
    $[665] = t298;
  } else {
    t298 = $[665];
  }
  let t299;
  if ($[666] !== t106 || $[667] !== t117 || $[668] !== t128 || $[669] !== t139 || $[670] !== t150 || $[671] !== t155 || $[672] !== t166 || $[673] !== t177 || $[674] !== t188 || $[675] !== t199 || $[676] !== t210 || $[677] !== t221 || $[678] !== t232 || $[679] !== t243 || $[680] !== t254 || $[681] !== t265 || $[682] !== t276 || $[683] !== t287 || $[684] !== t298) {
    t299 = <>{t106}{t117}{t128}{t139}{t150}{t155}{t166}{t177}{t188}{t199}{t210}{t221}{t232}{t243}{t254}{t265}{t276}{t287}{t298}</>;
    $[666] = t106;
    $[667] = t117;
    $[668] = t128;
    $[669] = t139;
    $[670] = t150;
    $[671] = t155;
    $[672] = t166;
    $[673] = t177;
    $[674] = t188;
    $[675] = t199;
    $[676] = t210;
    $[677] = t221;
    $[678] = t232;
    $[679] = t243;
    $[680] = t254;
    $[681] = t265;
    $[682] = t276;
    $[683] = t287;
    $[684] = t298;
    $[685] = t299;
  } else {
    t299 = $[685];
  }
  let t300;
  if ($[686] === Symbol.for("react.memo_cache_sentinel")) {
    t300 = [...Array(4)];
    $[686] = t300;
  } else {
    t300 = $[686];
  }
  let t301;
  if ($[687] !== t) {
    t301 = t300.map((__9, i_8) => {
      const notesIndex = i_8 + 1 as NumericRange<1, 4>;
      return <Trans key={i_8} t={t} i18nKey={`seoCreditCard:sections.9.notes.${notesIndex}`} />;
    });
    $[687] = t;
    $[688] = t301;
  } else {
    t301 = $[688];
  }
  let t302;
  if ($[689] !== t101 || $[690] !== t299 || $[691] !== t301) {
    t302 = <Table head={t101} body={t299} notes={t301} className="mt-8 mb-8" />;
    $[689] = t101;
    $[690] = t299;
    $[691] = t301;
    $[692] = t302;
  } else {
    t302 = $[692];
  }
  let t303;
  if ($[693] === Symbol.for("react.memo_cache_sentinel")) {
    t303 = {
      paragraph: <Paragraph />
    };
    $[693] = t303;
  } else {
    t303 = $[693];
  }
  let t304;
  if ($[694] !== t) {
    t304 = <Trans t={t} i18nKey="seoCreditCard:sections.9.content2" components={t303} />;
    $[694] = t;
    $[695] = t304;
  } else {
    t304 = $[695];
  }
  let t305;
  if ($[696] !== t302 || $[697] !== t304 || $[698] !== t90) {
    t305 = <>{t90}{t302}{t304}</>;
    $[696] = t302;
    $[697] = t304;
    $[698] = t90;
    $[699] = t305;
  } else {
    t305 = $[699];
  }
  let t306;
  if ($[700] !== t305 || $[701] !== t88) {
    t306 = {
      title: t88,
      content: t305
    };
    $[700] = t305;
    $[701] = t88;
    $[702] = t306;
  } else {
    t306 = $[702];
  }
  let t307;
  if ($[703] !== t) {
    t307 = t("seoCreditCard:sections.10.title");
    $[703] = t;
    $[704] = t307;
  } else {
    t307 = $[704];
  }
  let t308;
  if ($[705] === Symbol.for("react.memo_cache_sentinel")) {
    t308 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[705] = t308;
  } else {
    t308 = $[705];
  }
  let t309;
  if ($[706] !== t) {
    t309 = <Trans t={t} i18nKey="seoCreditCard:sections.10.content" components={t308} />;
    $[706] = t;
    $[707] = t309;
  } else {
    t309 = $[707];
  }
  let t310;
  if ($[708] !== t307 || $[709] !== t309) {
    t310 = {
      title: t307,
      content: t309
    };
    $[708] = t307;
    $[709] = t309;
    $[710] = t310;
  } else {
    t310 = $[710];
  }
  let t311;
  if ($[711] !== t) {
    t311 = t("core:faqs.title");
    $[711] = t;
    $[712] = t311;
  } else {
    t311 = $[712];
  }
  let t312;
  if ($[713] !== faqsData) {
    t312 = <FAQs data={faqsData} />;
    $[713] = faqsData;
    $[714] = t312;
  } else {
    t312 = $[714];
  }
  let t313;
  if ($[715] !== t311 || $[716] !== t312) {
    t313 = {
      title: t311,
      content: t312
    };
    $[715] = t311;
    $[716] = t312;
    $[717] = t313;
  } else {
    t313 = $[717];
  }
  let t314;
  if ($[718] !== t16 || $[719] !== t23 || $[720] !== t306 || $[721] !== t310 || $[722] !== t313 || $[723] !== t32 || $[724] !== t43 || $[725] !== t56 || $[726] !== t67 || $[727] !== t80 || $[728] !== t87) {
    t314 = [t16, t23, t32, t43, t56, t67, t80, t87, t306, t310, t313];
    $[718] = t16;
    $[719] = t23;
    $[720] = t306;
    $[721] = t310;
    $[722] = t313;
    $[723] = t32;
    $[724] = t43;
    $[725] = t56;
    $[726] = t67;
    $[727] = t80;
    $[728] = t87;
    $[729] = t314;
  } else {
    t314 = $[729];
  }
  let t315;
  if ($[730] !== menuPromoBanners || $[731] !== t12 || $[732] !== t314 || $[733] !== t5 || $[734] !== t7 || $[735] !== t9) {
    t315 = <SeoPageLayout menuPromoBanners={menuPromoBanners} seo={t5} title={t7} intro={t9} introButton={t12} sections={t314} />;
    $[730] = menuPromoBanners;
    $[731] = t12;
    $[732] = t314;
    $[733] = t5;
    $[734] = t7;
    $[735] = t9;
    $[736] = t315;
  } else {
    t315 = $[736];
  }
  return t315;
}
export const getStaticProps: GetStaticProps = async ctx => {
  const isAllowed = isAllowedRoute('kreditni-karta');
  if (!isAllowed) {
    return {
      notFound: true
    };
  }
  return {
    props: {
      menuPromoBanners: await getAllPageMenuPromoBanners(),
      ...(await getIntlProps(ctx, ['core', 'seoCreditCard']))
    }
  };
};